import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export interface AddCommentFooterProps {
  value: string;
  onChange: (value: string) => void;
  onAdd: () => void;
  hint?: React.ReactNode;
  disabled?: boolean;
}

export function CommentAddFooter({
  value,
  onChange,
  onAdd,
  hint,
  disabled = false,
}: AddCommentFooterProps) {
  const { t } = useTranslation();
  const isAddDisabled = disabled || value.trim().length === 0;

  return (
    <div className="flex flex-col gap-2">
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("comments.addPlaceholder")}
        rows={2}
        className="w-full"
        disabled={disabled}
      />
      <div
        className={cn(
          "flex items-center gap-4",
          hint ? "justify-between" : "justify-end",
        )}
      >
        {hint ? (
          <p className="text-muted-foreground text-xs shrink-0">{hint}</p>
        ) : null}
        <Button
          type="button"
          onClick={onAdd}
          size="sm"
          variant="outline"
          disabled={isAddDisabled}
        >
          <Plus className="h-4 w-4 mr-2" />
          {t("comments.add")}
        </Button>
      </div>
    </div>
  );
}
